import {fetchBaseStyle} from "@/api/base-style";

const state = () => ({
	baseStyle: undefined
})

// getters
const getters = {
	getBaseStyle(state) {
		return state.baseStyle
	}
}

// actions
const actions = {
	refresh({
		commit
	}, data) {
		console.log('更新的东西', data)
		fetchBaseStyle().then(res => {
			console.log(res)

			commit('setBaseStyle', res)
		})
	},
}

// mutations
const mutations = {
	setBaseStyle(state, baseStyle) {
		state.baseStyle = baseStyle
	},

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
